import { render } from "./Capital.vue?vue&type=template&id=6b3c7e86&scoped=true"
import script from "./Capital.vue?vue&type=script&lang=ts"
export * from "./Capital.vue?vue&type=script&lang=ts"

import "./Capital.vue?vue&type=style&index=0&id=6b3c7e86&scoped=true&lang=scss"
import "./Capital.vue?vue&type=style&index=1&id=6b3c7e86&lang=css"
script.render = render
script.__scopeId = "data-v-6b3c7e86"

export default script